export const NEW_PRODUCT_ID = 'new-product';
export const NEW_PROCESS_ID = 'new-process';
export const NEW_ORDER_ID = 'new-order';
export const NEW_WORK_ORDER_ID = 'new-work-order';
export const NEW_PROUDCTION_ORDER_ID = 'new-production-order';
export const NEW_ROBOT_PROGRAM_ID = 'new-robot-program';
export const NEW_FIXTURE_ID = 'new-fixture'
export const NEW_PLASTICS_ORDER_ID = 'new-plastics-order';